/**
 * Calculate the remaining time until a target date
 * @param {Date|string} endtime - The target date to countdown to
 * @returns {object} Object containing total milliseconds, days, hours, minutes, and seconds remaining
 */
function calculateTimeRemaining(endtime) {
  const now = new Date().getTime();
  const target = new Date(endtime).getTime();
  const diff = target - now;

  return {
    total: diff,
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
  };
}

/**
 * Formats a number to have at least 2 digits by padding with leading zeros
 * @param {number} number - The number to format
 * @returns {string} The formatted number as a string with at least 2 digits
 */
function formatNumber(number) {
  return number.toString().padStart(2, '0');
}

class Countdown {
  constructor(element) {
    this.container = element;
    this.endTime = new Date(element.getAttribute('expire-date'));
    this.elements = {
      days: element.querySelector('.js-countdown-day'),
      hours: element.querySelector('.js-countdown-hour'),
      minutes: element.querySelector('.js-countdown-minute'),
    };

    this.interval = null;
  }

  update() {
    const time = calculateTimeRemaining(this.endTime);

    if (time.total <= 0) {
      this.stop();
      this.container.innerHTML = 'Süre doldu';
      return;
    }

    Object.entries(this.elements).forEach(([key, el]) => {
      if (el) {
        const element = el;
        element.textContent = formatNumber(time[key]);
      }
    });
  }

  start() {
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}

/**
 *
 */
function initCountdowns() {
  const countdowns = Array.from(document.querySelectorAll('.js-countdown')).map(
    (element) => new Countdown(element),
  );

  countdowns.forEach((countdown) => countdown.start());

  window.addEventListener('pagehide', () => {
    countdowns.forEach((countdown) => countdown.stop());
  });
}

document.addEventListener('DOMContentLoaded', initCountdowns);
